import { render, staticRenderFns } from "./orderDetail2.vue?vue&type=template&id=d6c4a2ac&scoped=true"
import script from "./orderDetail2.vue?vue&type=script&lang=js"
export * from "./orderDetail2.vue?vue&type=script&lang=js"
import style0 from "./orderDetail2.vue?vue&type=style&index=0&id=d6c4a2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c4a2ac",
  null
  
)

export default component.exports